<div class="export-modal">
  <div class="modal-header ps-24px">
    <div class="export-modal-header">
      <h5>{{translate?.report.messages.changeOwnerConfirmation}}</h5>
    </div>

    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="modalRef.hide();"
      [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>
  
    <div class="modal-body pt-2">
      <!-- Destination label -->
      <div class="text-body">
        <span class="content">{{translate.report.messages.areYouSureToChangeOwenrshipThis}} {{dataToPass?.name}}? {{translate.report.messages.thisActionCannotUndone}}</span>
      </div>
    </div>
     <div class="modal-footer">
      <button type="button" class="custella-btn-white" (click)="modalRef.hide()">
        {{translate?.general.buttons.cancel.singular}}
      </button>
      <p-button [label]="translate?.general.buttons.save.singular" (onClick)="onSave()"></p-button>
    </div>
  

</div>